import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { AlertTriangle } from 'lucide-react';
export function CountdownTimerSection() {
  return <section className="py-6 md:py-10 px-4 bg-gradient-to-r from-urgency-700 via-urgency-600 to-urgency-700 text-white" data-id="element-81">
      <div className="max-w-3xl mx-auto text-center" data-id="element-82">
        <div className="flex items-center justify-center gap-3 mb-2 md:mb-4" data-id="element-83">
          <AlertTriangle className="w-6 h-6 text-yellow-300" data-id="element-84" />
          <p className="font-bold text-lg md:text-xl" data-id="element-85">
            Reserva válida por 15 minutos
          </p>
          <AlertTriangle className="w-6 h-6 text-yellow-300" data-id="element-86" />
        </div>
        <p className="text-white/80 text-sm mb-3 md:mb-5" data-id="element-87">
          Si no accedés, tu descuento pasa a la siguiente persona.
        </p>
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl py-3 px-5 md:py-5 md:px-8 inline-block border border-white/20" data-id="element-88">
          <CountdownTimer className="!text-white !text-3xl md:!text-4xl" data-id="element-89" />
        </div>
      </div>
    </section>;
}